"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bcpt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12 20.25C7.44375 20.25 3.75 16.5562 3.75 12C3.75 7.44375 7.44375 3.75 12 3.75C16.5562 3.75 20.25 7.44375 20.25 12C20.25 16.5562 16.5562 20.25 12 20.25ZM12 19.4235C16.0995 19.4235 19.4235 16.0995 19.4235 12C19.4235 7.9005 16.0995 4.5765 12 4.5765C7.9005 4.5765 4.5765 7.9005 4.5765 12C4.5765 16.0995 7.9005 19.4235 12 19.4235ZM16.5322 9.09C16.656 11.2935 14.6198 11.8755 14.6198 11.8755C16.947 12.2077 16.8225 14.2035 16.8225 14.2035C16.8225 17.445 13.206 17.5718 13.206 17.5718H8.13375V6.429H12.7073C16.5323 6.5955 16.5322 9.09 16.5322 9.09ZM10.7527 8.42475V11.1263H12.5828C12.5828 11.1263 13.8712 11.085 13.9537 10.0455V9.38025C13.9537 9.38025 13.9537 8.508 12.7065 8.42475H10.7527ZM14.2028 14.5372V13.8713C14.2028 13.8713 14.2027 12.9975 12.9562 12.9142H10.752V15.618H12.8317C12.8317 15.618 14.1202 15.5767 14.2035 14.5365L14.2028 14.5372Z", fill: color }));
}
exports["default"] = bcpt;
//# sourceMappingURL=bcpt.js.map